import { IProfileResponse } from "src/data/homeProfiles/types/homeProfilesTypes"

export function makeProfileCopy(profile: IProfileResponse): IProfileResponse {
  return { ...profile, name: profileNameCopy(profile.name) }
}

export function profileNameCopy(name?: string) {
  return `${name} Copy`
}
